import {IModalInstanceService} from 'webcommon/shared';
import {ImoTermDto} from 'webcommon/shared';

export type ImoSearchResult<TMultiSelect extends boolean> = TMultiSelect extends false ?
  ImoTermDto :
  ImoTermDto[];


// This should only be used as a fallback to TerminologySearch going forward, like in VersionedTerminologySearch.
// It should not be used directly outside of that.
export abstract class ImoSearchModalService {
  // TODO fix patient type
  // TODO: with the current code, these can return null if nothing is selected,
  // so the result type should really be ImoSearchResult<TMultiSelect> | null
  abstract openModal<TMultiSelect extends boolean = false>(
    patient: any,
    searchText: string,
    multiSelect?: TMultiSelect,
    hccModalFiltered?: boolean,
  ): Promise<ImoSearchResult<TMultiSelect>>;
  abstract openModalOnly<TMultiSelect extends boolean = false>(
    patient: any,
    searchText: string,
    multiSelect?: TMultiSelect,
    hccModalFiltered?: boolean,
  ): IModalInstanceService<ImoSearchResult<TMultiSelect>>;
}

export function ImoSearchModalServiceFactory(i: angular.auto.IInjectorService) {
  return i.get<ImoSearchModalService>('FncImoModal');
}

export const ImoSearchModalAjsProvider = {
  deps: ['$injector'],
  provide: ImoSearchModalService,
  useFactory: ImoSearchModalServiceFactory,
};
